import { type FC } from "react";
import { KeepButton } from "@legacy_user_frontend/components/ui_parts/buttons/keep_button";
import { TelContents } from "./src/TelContents";
import { ScoutButton } from "./src/ScoutButton";
import { type ButtonContentsProps } from "./src/button_contents_props";
import * as styles from "./styles.css";

export const ButtonContents: FC<ButtonContentsProps> = ({
  buttonContents: {
    keepButtonContent: { keepButtonUrl, keepButtonQuery },
    scoutButtonContent: { scoutedFlag, scoutDeadline, scoutedEntryUrl, clientShopId },
    entryButtonContent: { enterableFlag, entriedFlag },
  },
  telNumberContent: { showTellButtonFlag, telNumber },
  query,
  entryUrl,
  workCode,
  keepButtonEvent: { keepGaAction, keepGaLabel, keepAppierAction, keepFirebaseAction },
  entryButtonEvent: { entryGaAction, entryGaLabel, entryAppierAction },
  scoutButtonEvent: { scoutGaAction, scoutGaLabel },
  login,
  keepedFlag,
  className,
}) => (
  <div className={className}>
    <div className={styles.wrapper}>
      {showTellButtonFlag && <TelContents telNumber={telNumber} workCode={workCode} />}
      <div
        className={`js-link-expand__unlink ${styles.buttonList} ${
          scoutDeadline ? styles.buttonListScout : ""
        }`}
      >
        {Number(scoutDeadline) > 0 && (
          <div className={styles.scoutDeadlineOuter}>
            <p className={styles.scoutDeadlineText}>
              スカウトの受付期限まであと
              <span className={styles.scoutDeadlineNum}>{scoutDeadline}</span>日
            </p>
          </div>
        )}
        {/* キープボタン */}
        {(!login || (!entriedFlag && !scoutedFlag)) && (
          <div className={styles.keepButtonOuter}>
            <KeepButton
              url={keepButtonUrl}
              query={keepButtonQuery}
              gaAction={keepGaAction}
              gaLabel={keepGaLabel}
              appierAction={keepAppierAction}
              firebaseAction={keepFirebaseAction}
              workCode={workCode}
              hasKeeped={keepedFlag}
            />
          </div>
        )}
        {(() => {
          if (entriedFlag) {
            return (
              <div className={styles.appliedButtonOuter}>
                <div className={styles.disabledButton}>応募済み</div>
              </div>
            );
          }
          if (scoutedFlag) {
            return (
              <ScoutButton
                url={scoutedEntryUrl}
                clientShopId={clientShopId}
                gaAction={scoutGaAction}
                gaLabel={scoutGaLabel}
                workCode={workCode}
              />
            );
          }
          if (enterableFlag) {
            return (
              <div className={styles.buttonOuter}>
                <a
                  className={`${styles.applyButton} ga-click appier-click js-add-query-strings`}
                  href={entryUrl}
                  data-ga-action={entryGaAction}
                  data-ga-label={entryGaLabel}
                  data-appier-action={entryAppierAction}
                  data-query-str={query}
                >
                  応募画面へ進む
                </a>
              </div>
            );
          }
          return (
            <div className={styles.buttonOuter}>
              <div className={styles.disabledButton}>募集停止</div>
            </div>
          );
        })()}
      </div>
    </div>
  </div>
);
